import MainMenu from './MainMenu'

export default MainMenu
